import React from "react"

import { DeleteFavoritesOverlayView } from "./DeleteFavoritesOverlayView"

export interface DeleteFavoritesOverlayModel {
  closeOverlay: () => void
  confirm: () => void
}

export interface DeleteFavoritesOverlayProps
  extends DeleteFavoritesOverlayModel {
  autoFocus?: boolean
}

export const DeleteFavoritesOverlay = React.memo(
  (props: DeleteFavoritesOverlayProps) => (
    <DeleteFavoritesOverlayView {...props} />
  )
)
